import { useState, useEffect, useMemo } from "react";
import { useContext } from "react";
import { MyContext } from "../../context/ContextApi";
import useSWR, { mutate } from "swr";
import DashboardLayout from "../../components/LayoutContainers/DashboardLayout";
import { Col, Radio, Row, Typography } from "antd";
import { PoweroffOutlined, PrinterOutlined } from "@ant-design/icons";
import { dateCalculation } from "../../Services/TextChangeGlobal";
import { Button, Flex, Table, Modal } from "antd";
import dayjs from "dayjs";
import { useNavigate, Navigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { v4 as uuidv4 } from "uuid";
import uniqid from "uniqid";
import { submitPaymentForm } from "sabpaisa-pg-dev";

import useSWRMutation from "swr/mutation";
import logo from "../image/tatadavlogo2.png";

//import SabpaisaPaymentGateway from "../../sabPaisa/SabpaisaPaymentGateway";

import {
  getNewData,
  getDataById,
  deleteData,
  addDataTigget,
  updateData,
  addData,
  PayOnline,
  sendRequest,
  addDataTiggetwithOutArg,
  FeesDetailsUrl as feesKey,
} from "../../Api/api";

import { Card } from "antd";
import { ConfigFile } from "../../Services/ConfigFile";


function Dashboard() {
  const { generalSetting } = useContext(MyContext);
 // console.log("asssssssdasdasdasd", generalSetting);
  const [open, setOpen] = useState(false);

    const [settings, setSettings] = useState({
    Razorpay: {
      keyId: "",
      keySecret: "",
      isActive: false,
    },
    PineLab: {
      merchantId: "",
      saltKey: "",
      saltIndex: "1",
      isActive: false,
    },
    HDFC: {
      merchantId: "",
      merchantKey: "",
      isActive: false,
    },
    SabPaisa: {
      clientCode: "",
      transUserName: "",
      transUserPassword: "",
      authKey: "",
      authIV: "",
      isActive: false,
    },
  });
 

  const [img, setImage] = useState();
  //const { TextArea } = Input;
  const path = ConfigFile.BaseUrl;
  const naviagate = useNavigate();

  const [totalAmount, setTotalAmount] = useState(0);
  const [fineAmount, setFineAmount] = useState(0);

  const Userdata = JSON.parse(sessionStorage.getItem("Userdata"));
  const [selectionType, setSelectionType] = useState("radio");


  //console.log("dssdsadasdasdasd", Userdata);

  const [data, setSelectedRowValue] = useState([]);
 
  const { trigger, data: newdatael } = useSWRMutation(
    "/student/studentAPP/PayOnline/storeHdfcbeforepaymentGateway",
    addDataTiggetwithOutArg
  );


    const {
    isLoading,
    error,
    data: newData,
  } = useSWR(
    PayOnline,
    () =>
      getDataById(PayOnline, {
        session_id: JSON.parse(sessionStorage.getItem("Userdata"))?.session_id,
        search_date: new Date(),
        class_id: JSON.parse(sessionStorage.getItem("Userdata"))?.class_id,
      }),
    {
      onSuccess: (newdata) => {
      // console.log("Fetched settings:", data.payment_gateway[0]?.data);
       const data= newdata?.payment_gateway;
        console.log("data_data:1", data);
      if (data && data[0]) {
        console.log("data_data:2", data[0]);
        let parsed = {};
        try {
          parsed = JSON.parse(data[0]?.data || "{}");
        } catch (e) {
          parsed = {};
        }

         console.log("data_data:3", parsed);

        const rawConfig =
          parsed && typeof parsed === "object" && parsed.data && typeof parsed.data === "object"
            ? parsed.data
            : parsed;

         const paymentConfig = { ...rawConfig };

        if (!paymentConfig.PhonePe) {
          paymentConfig.PhonePe = rawConfig.PineLab || rawConfig.PineLabs || rawConfig.PhonePe;
        }
        if (!paymentConfig.Paytm) {
          paymentConfig.Paytm = rawConfig.HDFC || rawConfig.Paytm;
        }

        setSettings((prev) => ({
          Razorpay: { ...(prev.Razorpay || {}), ...(paymentConfig.Razorpay || {}) },
          PineLab: { ...(prev.PineLab || {}), ...(paymentConfig.PineLab || {}) },
          HDFC: { ...(prev.Paytm || {}), ...(paymentConfig.Paytm || {}) },
          SabPaisa: { ...(prev.SabPaisa || {}), ...(paymentConfig.SabPaisa || {}) },
        }));
       }
      },
    }
  );

  const activeGateways = useMemo(() => {
    if (!settings) return [];
    return Object.entries(settings)
      .filter(([, v]) => v && v.isActive)
      .map(([k]) => k);
  }, [settings]);


  const handleSubmit = async (e) => {
    e.preventDefault();

    const timestamp = Date.now();
    console.log("adadasaaaaaaa", newData);

    let currentDate = new Date();
let currentYearMonth = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, "0")}`;

  let fineDetails = [
  {
    next_due_date: currentYearMonth,
    total_late_fine: 400
  }
];
 

    var payload = {
      order_id: timestamp,
      amount: totalAmount,
      customer_id:
        newData?.data[0]?.firstname + " " + newData?.data[0]?.lastname,
      udf1: JSON.stringify(data[0]?.children),
      udf3: newData?.data[0]?.student_id,
      udf4: JSON.parse(sessionStorage.getItem("Userdata"))?.session_id,
      udf5: JSON.stringify(data[0]?.childrenc),
      udf6: fineAmount,
      udf7:JSON.stringify(fineDetails),
    };

    console.log("data________", payload);

    //}student/studentAPP/PayOnline/storeHdfcbeforepaymentGateway

    const result = await trigger(payload);
    if (result.Status == "Success") {

      console.log("data___33_____", settings?.SabPaisa);
       sessionStorage.setItem("SabPaisa", JSON.stringify(settings?.SabPaisa));
     
      const defaultValues = {
         clientCode:  settings?.SabPaisa?.clientCode,
         transUserName:  settings?.SabPaisa?.transUserName,
         transUserPassword:  settings?.SabPaisa?.transUserPassword,
         authKey:  settings?.SabPaisa?.authKey,
         authIV:  settings?.SabPaisa?.authIV,

        //  clientCode: "TATA82",
        //  transUserName: 'akshayasahoo60@gmail.com',
        //  transUserPassword: 'TATA82_SP25648',
        //  authKey: 'pcRzmUf/ZYEOnXgpEYX7xw7a8+gmTwfwOQ10C0OCgdE=',
        //  authIV: 'uRQzEIMz0UR58lkx7Od353uGeuSRjezaPWr+Rw6WYhEPelt3OYINZM2ZM8lSOrdS',

     
        payerName:newData?.data[0]?.firstname + " " + newData?.data[0]?.lastname,
        payerEmail: "tatadav2012@gmail.com",
        payerMobile: newData?.data[0]?.guardian_phone,
        amount: totalAmount,
        amountType: "INR",
        clientTxnId: timestamp,
        channelId: "npm",
       
        udf1: null,
        udf2: null,
        udf3: null,
        udf4: null,
        udf5: null,
        udf6: null,
        udf7: null,
        udf8: null,
        udf9: null,
        udf10: null,
        udf11: null,
        udf12: null,
        udf13: null,
        udf14: null,
        udf15: null,
        udf16: null,
        udf17: null,
        udf18: null,
        udf19: null,
        udf20: null,
       
        env: "prod",
        callbackUrl: ConfigFile.LocalUrl + "SuccessPage",
      };
      submitPaymentForm(defaultValues);
    } else {
    }
    console.log("data________", result);

    //
  };




  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  // const [selectedRowValue, setSelectedRowValue] = useState([]);
  const [loading, setLoading] = useState(false);


  const hasSelected = selectedRowKeys?.length > 0;
  // const hasSelected = selectedRowKeys?.length > 0;

  const enterLoading = () => {
    sessionStorage.clear();
    naviagate("/");
  };

  if (localStorage?.getItem("isAuthenticated")) {
    localStorage.clear();
    naviagate("/");
  }

  const viewStatus = (billdate) => {
    var today = dayjs().format("YYYY-MM-DD");
    var nextbill = dayjs(billdate?.next_due_date).format("YYYY-MM-DD");
    const date1 = dayjs(billdate?.next_due_date).diff(today);

    return (
      <>
        {date1 <= 0 ? (
          <>
            <span
              style={{ marginRight: "5px", fontSize: "10px" }}
              className="label label-danger"
            >
              Due
            </span>
          </>
        ) : (
          <>
            <span
              style={{
                marginRight: "5px",
                fontSize: "10px",
                backgroundColor: "#cd8080",
              }}
              className="label"
            >
              Upcoming
            </span>
          </>
        )}{" "}
      </>
    );
  };

  const viewDetails = async (emi_id, type) => {
    console.log("sssssssssssss", emi_id);
    naviagate(`/FeeReciptPrint?receipt_id=${emi_id}&type=${type}`);
  };

  const AmountFormat = (amount) => {
    // const { generalSetting } = useContext(MyContext);
    return (
      <>
        {/* {newData?.settings[0]?.currency_symbol}  */}₹
        {Number(amount).toLocaleString("en-IN")}
      </>
    );
    //return {generalSetting?.currency_symbol} amount
  };

  const paid_columns = [
    {
      title: "Recipt",
      dataIndex: "fees_name",
      render: (item, record, index) => (
        <div style={{ fontSize: "11px" }}>
          {record?.id ? record?.fees_name : record?.receipt_no}
          {record.id ? (
            <>{dateCalculation(record.duration, record?.fee_collect_for)}</>
          ) : (
            <></>
          )}
        </div>
      ),
      onCell: (record, index) => ({
        colSpan: record?.id ? 2 : 1,
      }),
    },
    {
      title: "Date",
      key: "date",
      render: (item, record, index) => {
        return (
          <>
            {record.id ? (
              <></>
            ) : (
              <div style={{ fontSize: "11px" }}>
                <div
                  style={{ marginRight: "5px", fontSize: "11px" }}
                  className="label label-success"
                >
                  {record?.duration
                    ? record?.fee_collect_for
                    : record?.receipt_date}
                </div>
              </div>
            )}
          </>
        );
      },
      onCell: (record, index) => ({
        colSpan: record?.id ? 0 : 1,
      }),
    },
    {
      title: "Amount",
      key: "amount",
      dataIndex: "paid_amount",
      render: (item, record, index) => {
        return (
          <div style={{ fontSize: "11px" }}>
            {record?.id ? (
              <>
                {AmountFormat(record.paid_amount)}
                <div
                  style={{
                    fontWeight: "bold",
                    fontSize: "12px",
                    color: "#f30000",
                  }}
                >
                  Fine {AmountFormat(record.late_fine)}{" "}
                </div>
              </>
            ) : (
              <div style={{ flexDirection: "row" }}>
                <div>Total : {AmountFormat(record.total_payable_amount)}</div>
                <div>Discount : {AmountFormat(record.fees_discount)}</div>
                <div>Paid : {AmountFormat(record.total_paid_amount)}</div>
              </div>
            )}
          </div>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "operation",
      render: (item, record, index) => {
        return (
          <div style={{ fontSize: "11px" }}>
            {record?.id ? (
              <></>
            ) : (
              <>
                <span
                  style={{ marginRight: "5px", fontSize: "10px" }}
                  className="label label-success"
                >
                  Paid
                </span>
                {/* <Button
                  style={{ padding: "0px",border:"none" }}
                  onClick={() =>
                    viewDetails(record?.fees_receipt_id, "feesmaster")
                  }
                > */}

                {/* <PrintIcon sx={{ color: "#3892ee" }} fontSize="small" /> */}
                {/* </Button> */}
                <PrinterOutlined
                  onClick={() =>
                    viewDetails(record?.fees_receipt_id, "feesmaster")
                  }
                  style={{ color: "#3892ee", cursor: "pointer", fontSize: 16 }}
                />
              </>
            )}
          </div>
        );
      },
    },
  ];

  const rowSelection = {
    selectedRowKeys,
    onChange: (newselectedRowKeys, selectedRows) => {

      setSelectedRowValue(selectedRows);

      setSelectedRowKeys(newselectedRowKeys);
    },

    onSelect: (record, selected, selectedRows) => {
      setTotalAmount(0);
      // const [fineAmount, setFineAmount] = useState(0);
      setFineAmount(0);
      let allAmount = 0;
      let fine = 0;
      if (selected) {
        selectedRows.forEach((data, index) => {
          console.log("sadasdasd", data);
          fine=Number(data.total_late_fine);
          allAmount +=
            Number(data.total_due_amount) + Number(data.total_late_fine);
        });
        setFineAmount(Number(fine));
        setTotalAmount(Number(allAmount));
      } else {
        setFineAmount(Number(fineAmount) - Number(record.total_late_fine));
        setTotalAmount(
          Number(totalAmount) -
            Number(
              Number(record.total_due_amount) + Number(record.total_late_fine)
            )
        );
      }
    },

    onSelectAll: (selected, selectedRows, changeRows) => {
      setTotalAmount(0);
      setFineAmount(0);
      let allAmount = 0;
      if (selected) {
        selectedRows.forEach((data, index) => {
          allAmount +=
            Number(data.total_due_amount) + Number(data.total_late_fine);
        });
        setTotalAmount(allAmount);
      } else {
        setTotalAmount(0);
        setFineAmount(0);
      }
    },
  };

  const upcoming_columns = [
    {
      title: "Title",
      dataIndex: "fees_name",
      key: "1",
      render: (item, record, index) => {
        return (
          <>
            <div>
              <div>{record?.fees_name}</div>
              <div
                style={{
                  marginRight: "5px",
                  fontSize: "12px",
                  color: "#000",
                  fontWeight: "bold",
                }}
                className=""
              >
                {record?.group_name}
              </div>
            </div>
          </>
        );
      },
    },
    {
      title: "Next Due Date",
      dataIndex: "next_due_date",
      key: "2",
      render: (item, record, index) => {
        return (
          <>
            <div>
              {dateCalculation(record.duration, record?.next_due_date)}
              <div
                style={{
                  marginRight: "5px",
                  fontSize: "12px",
                  color: "#f30000",
                }}
                className=""
              >
                {record?.next_due_date}
              </div>
            </div>
          </>
        );
      },
    },

    {
      title: "Amount",
      key: "amount",
      dataIndex: "amount",

      render: (item, record, index) => {
        console.log("sadasdasdadasdas", record);
        return (
          <div
            style={{
              display: "inline-block",
              fontWeight: "bold",
              fontSize: "12px",
            }}
          >
            {" "}
            {record?.total_due_amount
              ? AmountFormat(record?.total_due_amount)
              : AmountFormat(record?.due_amount)}
          </div>
        );
      },
    },

    {
      title: "Fine",
      dataIndex: "total_late_fine",
      key: "total_late_fine",
      render: (item, record, index) => {
        return (
          <>
            <div>
              <div
                style={{
                  marginRight: "5px",
                  fontSize: "12px",
                  color: "#f30000",
                  fontWeight: "bold",
                }}
                className=""
              >
                {
                  record?.total_late_fine
                    ? AmountFormat(record?.total_late_fine)
                    : ""
                  //  AmountFormat(record?.late_fine)
                }
              </div>
            </div>
          </>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "operation",
      render: (_, record) => {
        return <> {viewStatus(record)}</>;
      },
    },
  ];

  

  return (
    <DashboardLayout>
      {/* {newData?.receipt_info[0] ? ( */}
      {!isLoading ? (
        <div style={{ width: "100%", margin: 0, padding: 0, lineHeight: 1.5 }}>
          <nav
            className="navBar"
            style={{
              // display: "flex",
              // justifyContent:"space-between",
              // // justifyContent:"center",
              // alignItems:"center",
              // flexWrap: "wrap",
              padding: 5,
              paddingTop: 10,
              backgroundColor: newData?.receipt_info[0]?.color_code
                ? newData?.receipt_info[0]?.color_code
                : "#e6eefc",
            }}
          >
            <div
              className="header_div"
             
            >
              <div>
             
                <img
                  className="branchLogo"
                 src={logo}
                  style={{
                   
                    textAlign: "right",
                  }}
                />
              </div>
              <div
                style={{
                
                  color: "#292929",
                  fontWeight: "bold",
                }}
                className="school_name"
              >
                <div>{newData?.receipt_info[0]?.name}</div>
                <div
                  className="headerDetails"
                  style={{ color: "#000", fontWeight: "500" }}
                >
                  {newData?.receipt_info[0]?.affliated_description}
                </div>
                <div
                  className="headerDetails headerDetails2"
                  style={{ color: "#000", fontWeight: "500" }}
                >
                  {newData?.receipt_info[0]?.address}
                </div>
                <div
                  className="headerDetails"
                  style={{ color: "#000", fontWeight: "500" }}
                >
                  Phone : {newData?.receipt_info[0]?.offical_number}
                </div>
                {/* <div style={{ color: "#000",fontSize:14,fontWeight:"500" }}>
                  Email : {newData?.receipt_info[0]?.email_id}
                </div> */}
                {newData?.receipt_info[0]?.affliated_number && (
                  <div
                    className="headerDetails"
                    style={{ color: "#000", fontWeight: "500" }}
                  >
                    Affiliation Number :{" "}
                    {newData?.receipt_info[0]?.affliated_number}
                  </div>
                )}
              </div>
              {/* </Col> */}
              {/* </Row> */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  paddingTop: 5,
                  paddingRight: 5,
                  width: "100%",
                }}
              >
                <Flex gap="small" wrap>
                  <Button
                    type="primary"
                    icon={<PoweroffOutlined />}
                    loading={false}
                    onClick={() => enterLoading()}
                  />
                </Flex>
              </div>
            </div>
          </nav>

          <div style={{ backgroundColor: "#fff", padding: 2 }}>
            <h2 style={{ textAlign: "center" }}> Student Information</h2>

            <div>
              <div>
                <div sx={{ border: 1 }}>
                  <div
                  // container
                  >
                    <Row>
                      <Col xs={{ flex: "100%" }}>
                        <div></div>
                        <div>
                          <div>
                            {" "}
                            <Row
                              style={{ border: "1px solid #000", padding: 5 }}
                            >
                              {" "}
                              <Col xs={{ flex: "100%" }} md={{ flex: "50%" }}>
                                {" "}
                                Name:{" "}
                                <span style={{ fontWeight: "bold" }}>
                                  {" "}
                                  {newData?.data[0]?.firstname}{" "}
                                  {newData?.data[0]?.lastname}
                                </span>
                              </Col>
                              <Col xs={{ flex: "100%" }} md={{ flex: "50%" }}>
                                {" "}
                                Fathers Name:{" "}
                                <span style={{ fontWeight: "bold" }}>
                                  {" "}
                                  {newData?.data[0]?.father_name}{" "}
                                </span>
                              </Col>
                              <Col xs={{ flex: "100%" }} md={{ flex: "50%" }}>
                                {" "}
                                Admission No.:{" "}
                                <span style={{ fontWeight: "bold" }}>
                                  {newData?.data[0]?.admission_no}
                                </span>
                              </Col>
                              <Col xs={{ flex: "100%" }} md={{ flex: "50%" }}>
                                {" "}
                                Fathers Phone:{" "}
                                <span style={{ fontWeight: "bold" }}>
                                  {newData?.data[0]?.guardian_phone}
                                </span>
                              </Col>
                              <Col xs={{ flex: "100%" }} md={{ flex: "50%" }}>
                                {" "}
                                Class :{" "}
                                <span style={{ fontWeight: "bold" }}>
                                  {newData?.data[0]?.class} ({" "}
                                  {newData?.data[0]?.section} )
                                </span>
                              </Col>
                              <Col xs={{ flex: "100%" }} md={{ flex: "50%" }}>
                                {" "}
                                Roll No:{" "}
                                <span style={{ fontWeight: "bold" }}>
                                  {newData?.data[0]?.roll_no}
                                </span>
                              </Col>
                              {newData?.data[0]?.batch_name ? (
                                <Col xs={{ flex: "100%" }} md={{ flex: "50%" }}>
                                  {" "}
                                  Batch Name:{" "}
                                  <span style={{ fontWeight: "bold" }}>
                                    {newData?.data[0]?.batch_name}
                                  </span>
                                </Col>
                              ) : null}
                              {newData?.data[0]?.courses_name ? (
                                <Col xs={{ flex: "100%" }} md={{ flex: "50%" }}>
                                  {" "}
                                  Course Name:{" "}
                                  <span style={{ fontWeight: "bold" }}>
                                    {newData?.data[0]?.courses_name}
                                  </span>
                                </Col>
                              ) : (
                                <></>
                              )}
                            </Row>
                          </div>
                        </div>
                      </Col>
                      <Col xs={{ flex: "100%" }}>
                        {newData?.emi_data && newData?.emi_data.length ? (
                          <>
                            <div>
                              <h2 style={{ textAlign: "center" }}>
                                Payment Details
                              </h2>
                            </div>
                          </>
                        ) : (
                          <></>
                        )}

                        <div
                          style={{
                            flex: "auto",
                            display: "flex",
                            flexWrap: "wrap",
                          }}
                        >
                          {newData?.upcoming_payments.length ? (
                            <>
                              <div
                                className="table-responsive"
                                style={{ flexGrow: 1, border: "1px solid" }}
                              >
                                <form className="xyz" onSubmit={handleSubmit}>
                                  <div id="renderSabPaisa"></div>
                                  <div
                                    style={{
                                      width: "100%",
                                      // border: "1px solid",
                                      borderBottom: "1px solid",
                                      fontSize: "14px",
                                      color: "#000",
                                      fontWeight: "bold",
                                      padding: "5px",
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    Upcoming Fees
                                    <Button
                                      style={{ float: "right" }}
                                      // type="primary"
                                      type="primary"
                                      htmlType="submit"
                                      // onClick={(e) => submitAllData()}
                                      //</div>onClick={start}
                                      disabled={!hasSelected}
                                      loading={loading}
                                    >
                                      {`Pay Now `} {AmountFormat(totalAmount)}
                                    </Button>
                                    {/* :null} */}
                                  </div>
                                  {/* <SabpaisaPaymentGateway
                                    clientCode={clientCode}
                                    transUserName={transUserName}
                                    transUserPassword={transUserPassword}
                                    authkey={authkey}
                                    authiv={authiv}
                                    payerName={newData?.data[0]?.firstname+" "+newData?.data[0]?.lastname}
                                    payerEmail={newData?.data[0]?.email?newData?.data[0]?.email:"noreplay@tatadavjoda.com"}
                                    payerMobile={newData?.data[0]?.guardian_phone}
                                    clientTxnId={clientTxnId}
                                    amount={totalAmount}
                                    payerAddress={newData?.data[0]?.address}
                                    callbackUrl={callbackUrl}
                                    isOpen={isOpen}
                                    udf1={udf1}
                                    udf2={udf2}
                                    udf3={udf3}
                                   // data={data}
                                  /> */}
                                </form>
                                <Table
                                  columns={upcoming_columns}
                                  pagination={false}
                                  // rowSelection={rowSelection}
                                  rowSelection={{
                                    type: selectionType,
                                    ...rowSelection,
                                  }}
                                  // rowSelection={{ ...rowSelection, checkStrictly }}
                                  //  dataSource={datarow}
                                  dataSource={newData?.upcoming_payments}
                                  size="small"
                                  rowKey="id"
                                />
                              </div>
                            </>
                          ) : (
                            <></>
                          )}
                          {newData?.Paid_fees.length ? (
                            <div
                              className="table-responsive"
                              style={{ flexGrow: 1, border: "1px solid" }}
                            >
                              <div
                                style={{
                                  width: "100%",
                                  // border: "1px solid",
                                  borderBottom: "1px solid",
                                  fontSize: "14px",
                                  color: "#000",
                                  fontWeight: "bold",
                                  padding: "13px",
                                }}
                              >
                                <span>Paid Fees</span>
                              </div>
                              <Table
                                columns={paid_columns}
                                pagination={false}
                                //  rowSelection={{ ...rowSelection, checkStrictly }}
                                dataSource={newData?.Paid_fees}
                                size="small"
                                rowKey="fees_receipt_id"
                              />
                            </div>
                          ) : (
                            <></>
                          )}
                        </div>
                        {newData?.emi_data && newData?.emi_data.length ? (
                          <></>
                        ) : (
                          <></>
                        )}
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : isLoading ? null : (
        <div>No Data Found</div>
      )}
    </DashboardLayout>
  );
}

export default Dashboard;
